/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { CropVariety } from 'src/app/shared/models';

export enum CropVarietyActionTypes {
  LoadCropVarietiesByCropIdRequest = '[CropVariety] Load crop varieties by crop id request',
  LoadCropVarietiesByCropIdSuccess = '[CropVariety] Load crop varieties by crop id success',
  LoadCropVarietiesByCropIdsRequest = '[CropVariety] Load crop varieties by list of crop ids request',
  LoadCropVarietiesByCropIdsSuccess = '[CropVariety] Load crop varieties by list of crop ids success',
  LoadCropVarietiesFailed = '[CropVariety] Load cultivation targets failed',
}

export class LoadCropVarietiesByCropIdRequest implements Action {
  readonly type = CropVarietyActionTypes.LoadCropVarietiesByCropIdRequest;

  constructor(public readonly cropId: number) {}
}

export class LoadCropVarietiesByCropIdSuccess implements Action {
  readonly type = CropVarietyActionTypes.LoadCropVarietiesByCropIdSuccess;

  constructor(
    public readonly cropId: number,
    public readonly cropVarieties: CropVariety[],
  ) {}
}

export class LoadCropVarietiesByCropIdsRequest implements Action {
  readonly type = CropVarietyActionTypes.LoadCropVarietiesByCropIdsRequest;

  constructor(public readonly cropIds: number[]) {}
}

export class LoadCropVarietiesByCropIdsSuccess implements Action {
  readonly type = CropVarietyActionTypes.LoadCropVarietiesByCropIdsSuccess;

  constructor(
    public readonly cropIds: number[],
    public readonly cropVarieties: CropVariety[],
  ) {}
}

export class LoadCropVarietiesFailed implements Action {
  readonly type = CropVarietyActionTypes.LoadCropVarietiesFailed;

  constructor(public readonly message: string) {}
}

export type CropVarietyActions =
  | LoadCropVarietiesByCropIdRequest
  | LoadCropVarietiesByCropIdSuccess
  | LoadCropVarietiesByCropIdsRequest
  | LoadCropVarietiesByCropIdsSuccess
  | LoadCropVarietiesFailed;
